module.exports = "/wp-content/plugins/farmacy/assets/js/images/sprite-4c575d1418430f28c32f5d1b640e2871.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/cart-payment/credit-card-sprites/img/sprite.png
 ** module id = 551
 ** module chunks = 1 9 15 83
 **/